import * as types from '../constants/ActionTypes';

export function receiveSessionUser (user) {
	return { type: types.RECEIVE_SESSION_USER, user };
}



// WEBPACK FOOTER //
// ./src/assets/js/actions/auth.js